(function () {
  'use strict';
  var root = document.getElementById('kanen-all-reviews');
  if (!root || root.dataset.reviewUx) return;
  root.dataset.reviewUx = 'ready';
  var panelId = 'kanen-review-results';
  var pendingPageFocus = null;

  function restorePageFocus() {
    if (!pendingPageFocus) return;
    if (Date.now() - pendingPageFocus.started > 15000) {
      pendingPageFocus = null;
      return;
    }
    var current = root.querySelector('.jm-pagination-controls [aria-current="page"]');
    var body = root.querySelector('.jm-review-widget__body[role="tabpanel"]');
    if (!current || current.disabled || !body ||
      current.getAttribute('aria-label') === pendingPageFocus.previousPage) return;
    var active = document.activeElement;
    var restore = active === document.body || active === pendingPageFocus.button;
    pendingPageFocus = null;
    if (restore) {
      if (!body.hasAttribute('tabindex')) body.tabIndex = -1;
      body.focus();
    }
  }

  // Vendor pagination replaces the focused button; resume at the new reviews.
  root.addEventListener('click', function (event) {
    var button = event.target.closest('.jm-pagination-controls button');
    var current = root.querySelector('.jm-pagination-controls [aria-current="page"]');
    if (!button || button.disabled || event.detail !== 0 || document.activeElement !== button || !current) return;
    pendingPageFocus = { button: button, previousPage: current.getAttribute('aria-label'), started: Date.now() };
  }, true);

  document.addEventListener('focusin', function (event) {
    if (pendingPageFocus && event.target !== pendingPageFocus.button) pendingPageFocus = null;
  });
  ['pointerdown', 'keydown'].forEach(function (type) {
    document.addEventListener(type, function () { pendingPageFocus = null; }, true);
  });

  function tabs() {
    return Array.from(root.querySelectorAll('.jdgm-tab[role="tab"]'));
  }

  function restoreTabEntry(controls) {
    var entry = controls.find(function (tab) { return tab.getAttribute('aria-selected') === 'true'; }) ||
      controls.find(function (tab) { return tab.tabIndex === 0; }) || controls[0];
    controls.forEach(function (tab) { tab.tabIndex = tab === entry ? 0 : -1; });
  }

  function syncPanel() {
    // Histogram buttons already name the rating and count; their single star is decorative.
    root.querySelectorAll('.jm-histogram-row[role="button"][aria-label]').forEach(function (row) {
      if (!/reviews with [1-5] star rating/.test(row.getAttribute('aria-label'))) return;
      row.querySelectorAll('.jm-star-rating[role="img"]').forEach(function (star) {
        if (star.getAttribute('aria-hidden') !== 'true') star.setAttribute('aria-hidden', 'true');
      });
    });
    var controls = tabs();
    var selected = controls.find(function (tab) { return tab.getAttribute('aria-selected') === 'true'; });
    if (!selected) restoreTabEntry(controls);
    var body = root.querySelector('.jm-review-widget__body');
    if (!body || controls.length !== 2) return;
    // Leave vendor-provided panels intact if a future widget version supplies them.
    if (body.id !== panelId && (body.id || controls.some(function (tab) {
      var panel = document.getElementById(tab.getAttribute('aria-controls'));
      return panel && root.contains(panel);
    }))) return;
    body.id = panelId;
    body.setAttribute('role', 'tabpanel');
    if (selected) {
      body.setAttribute('aria-labelledby', selected.id);
      body.removeAttribute('aria-label');
    } else {
      // Rating filters can show both review types with neither tab selected.
      body.removeAttribute('aria-labelledby');
      body.setAttribute('aria-label', 'Customer reviews');
      restoreTabEntry(controls);
    }
    body.tabIndex = 0;
    controls.forEach(function (tab) { tab.setAttribute('aria-controls', panelId); });
  }

  root.addEventListener('keydown', function (event) {
    if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
    var controls = tabs();
    var index = controls.indexOf(event.target);
    if (index < 0) return;
    if (event.key === 'ArrowLeft') index = (index + controls.length - 1) % controls.length;
    else if (event.key === 'ArrowRight') index = (index + 1) % controls.length;
    else if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = controls.length - 1;
    else return;
    event.preventDefault();
    // Manual activation avoids loading reviews for each arrow press; native Enter/Space selects.
    controls.forEach(function (tab, position) { tab.tabIndex = position === index ? 0 : -1; });
    controls[index].focus();
  });

  root.addEventListener('focusout', function (event) {
    var list = event.target.closest('[role="tablist"]');
    if (!list || list.contains(event.relatedTarget)) return;
    restoreTabEntry(tabs());
  });

  new MutationObserver(function () {
    syncPanel();
    restorePageFocus();
  }).observe(root, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['aria-selected', 'aria-current', 'disabled']
  });
  syncPanel();
})();
